/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef */
/* eslint-disable no-console */

class JobFunction {
  constructor(filter) {
    this.checked = [];
    this.legendSpan = filter.querySelector('.fieldset-legend');
    const checkboxes = filter.querySelectorAll('.js-form-item');
    this.actions(checkboxes);
  }

  actions(checkboxes) {
    checkboxes.forEach(elm => {
      const checkbox = elm.getElementsByTagName('input')[0];
      const value = elm.getElementsByTagName('label')[0].firstChild.data;
      if (checkbox.checked) {
        this.checked.push(value);
      }
      checkbox.addEventListener('click', () => {
        if (!checkbox.checked) {
          this.removeChecked(value);
        }
        if (checkbox.checked) {
          this.addChecked(value);
        }
      });
    });
    this.setLegend();
  }

  setLegend() {
    let crumb;
    if (this.checked.length > 1) {
      crumb = `${this.checked[0]} , ...`;
      this.legendSpan.innerText = crumb;
    }
    if (this.checked.length === 1) {
      crumb = `${this.checked[0]}`;
      this.legendSpan.innerText = crumb;
    }
  }

  removeChecked(value) {
    const index = this.checked.indexOf(value);
    if (index > -1) {
      this.checked.splice(index, 1);
    }
    this.setLegend();
  }

  addChecked(value) {
    this.checked.push(value);
    this.setLegend();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const jobFunctionFilter = document.getElementById('edit-function--wrapper');
  if (jobFunctionFilter) {
    window.JobFunction = new JobFunction(jobFunctionFilter);
  }
});
